module.exports = __webpack_public_path__ + "20250721160708/img/feedback_icon.1e0ae43c.png";